import React, { useEffect, useState } from 'react';
import './HorizontalTabSec.scss';

export type HorizontalTabsSecPanelProps = {
  id: string;
  label: React.ReactNode;
  children: React.ReactNode;
};

export const HorizontalTabsSecPanel = ({ children }: HorizontalTabsSecPanelProps) => (
  <>{children}</>
);

type HorizontalTabsSecProps = {
  children: React.ReactNode;
  defaultActiveId?: string;
  className?: string;
  hideTabs?: boolean;
  onTabChange?: (activeId: string) => void;
};

const HorizontalTabsSec = ({
  children,
  defaultActiveId,
  className = '',
  hideTabs = false,
  onTabChange,
}: HorizontalTabsSecProps) => {
  const panels = React.Children.toArray(children).filter(
    React.isValidElement
  ) as React.ReactElement<HorizontalTabsSecPanelProps>[];
  const firstPanelId = panels[0]?.props.id;
  const [activeId, setActiveId] = useState(defaultActiveId || firstPanelId);

  useEffect(() => {
    if (!panels.some(panel => panel.props.id === activeId)) {
      setActiveId(defaultActiveId || firstPanelId);
    }
  }, [activeId, defaultActiveId, firstPanelId, panels]);

  const handleTabClick = (panelId: string) => {
    setActiveId(panelId);
    onTabChange?.(panelId);
  };

  return (
      <div className={`horizontal-tabs-sec ${className}`.trim()}>
        {!hideTabs && (
          <div className="horizontal-tabs-sec__list" role="tablist" aria-label="Sections">
        {panels.map(panel => {
          const isActive = panel.props.id === activeId;
          return (
            <button
              key={panel.props.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`horizontal-tabs-sec__tab${isActive ? ' horizontal-tabs-sec__tab--active' : ''}`}
              onClick={() => handleTabClick(panel.props.id)}
            >
              {panel.props.label}
            </button>
          );
        })}
          </div>
        )}
        {panels.map(panel => (
        <div
          key={panel.props.id}
          role="tabpanel"
          hidden={panel.props.id !== activeId}
          className="horizontal-tabs-sec__panel"
        >
          {panel.props.children}
        </div>
      ))}
    </div>
  );
};

export default HorizontalTabsSec;
